import { WidgetDataType, WidgetNoneType } from '@atlas-metrics/microsite-types';
import React from 'react';

import { FormatValueFn } from '@/hooks/useFormatValue';

import { ProgressChartWithLegends } from './ProgressChartWithLegends';
import ElevatedCard from '../ui/ElevatedCard';
import HorizontalDivider from '../ui/HorizontalDivider';
import WidgetRow from '../ui/WidgetRow';

import { ProgressChartDisclosureResult } from '@/types';

type Props = {
  disclosureTitle: string;
  data: ProgressChartDisclosureResult[];
  dataType: WidgetDataType | WidgetNoneType;
  formatValue: FormatValueFn;
};

const ProgressChartWidget: React.FC<Props> = ({
  disclosureTitle,
  data,
  dataType,
  formatValue,
}) => {
  const shouldShowTitle = () => {
    if (data?.length > 1) {
      return true;
    }

    if (data?.length === 1 && data[0].name !== disclosureTitle) {
      return true;
    }

    return false;
  };

  return (
    <ElevatedCard>
      {shouldShowTitle() && (
        <>
          <WidgetRow title={disclosureTitle} hideHorizontalDivider />
          <HorizontalDivider />
        </>
      )}
      <ProgressChartWithLegends
        formatValue={formatValue}
        data={data}
        dataType={dataType}
      />
    </ElevatedCard>
  );
};

export default ProgressChartWidget;
